import { Button } from "@heroui/button";
import React from "react";

function SidebarCompany({ sections, activeSection, onSectionSelect }) {
  const handleSectionSelect = (sectionId) => {
    onSectionSelect(sectionId);
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "center", // or "start" or "center"
        });
      } else {
        console.error(`Element with id ${sectionId} not found`);
      }
    }, 100); // Adjust delay as needed
  };

  return (
    <div>
      {/* Desktop Sidebar: Vertical */}
      <nav className="hidden md:flex md:flex-col items-center justify-center sticky top-0 h-400 shadow-md rounded-lg w-full border bg-white p-6 overflow-auto">
        <ul role="tablist">
          {sections.map((section) => (
            <li
              key={section.id}
              role="tab"
              className={`sidebar-item ${
                activeSection === section.id ? "text-1B51CA" : ""
              }`}
              aria-selected={activeSection === section.id}
            >
              <Button
                size="sm"
                className="mt-2 w-full text-center"
                variant="flat"
                onClick={() => handleSectionSelect(section.id)}
                aria-controls={section.id}
              >
                {section.label}
              </Button>
            </li>
          ))}
        </ul>
      </nav>
      {/* Mobile Sidebar: Horizontal */}
      <nav className="md:hidden sticky top-0 z-auto rounded-lg w-full p-3 overflow-x-auto">
        <ul role="tablist" className="flex mb-2 whitespace-nowrap">
          {" "}
          {/* Ensure this is a <ul> element */}
          {sections.map((section) => (
            <li
              key={section.id}
              role="tab"
              className={`sidebar-item ${
                activeSection === section.id ? "text-1B51CA" : ""
              } mr-4`}
              aria-selected={activeSection === section.id}
            >
              <Button
                color="default"
                variant="flat"
                onClick={() => handleSectionSelect(section.id)}
              >
                {section.label}
              </Button>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}

export default SidebarCompany;
